import Swiper, { Navigation } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import $ from "jquery";

export default class SwiperBeforeAfter {
    _slider;
    _objSlider;
    _classSlider;

    constructor(opts = {}) {
        this._slider = null;
        this._objSlider = null;
        this._classSlider = opts.classSlider || '.js-swiper-problemJournalPromoBeforeAfter';
    }

    _createSlider(){
        this._slider = new Swiper(this._classSlider, {
            modules: [Navigation],
            loop: false,
            allowTouchMove: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
        });
    }

    _initBeforeAfter(){
        const rangeItems = this._objSlider.querySelectorAll('input[type="range"]');
        rangeItems.forEach((item) => {
            item.addEventListener('input', (e) => {
                const parent = e.target.parentElement;
                const before = parent.querySelector('.js-before-el');
                before.style.setProperty('width', `${e.target.value}%`);

                const range = parent.querySelectorAll('.js-range-el');
                range.forEach((el) => {
                    el.style.setProperty('left', `${e.target.value}%`);
                });
            });
        });
    }

    init(){
        this._objSlider = document.querySelector(this._classSlider);
        if (!this._slider && this._objSlider) {
            this._createSlider();
            this._initBeforeAfter();
            console.log('Slider Video init');
        } else {
            console.log('Error Slider Video init');
        }
    }
}
